export const ReactionsType = {
  DISPATCH_HEART_ANIMATION: 'heart',
  DISPATCH_CONFETTI_ANIMATION: 'confetti',
  DISPATCH_CLAPPING_ANIMATION: 'clapping',
  DISPATCH_TIMER_ANIMATION: 'timer',
  DISPATCH_ARROW_ANIMATION: 'arrow',
}
